// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconDownload } from '@tabler/icons';

const icons = { IconDownload };

const installs = {
    id: 'installs',
    type: 'group',
    children: [
        {
            id: 'installs-page',
            title: <FormattedMessage id="installs" />,
            type: 'item',
            icon: icons.IconDownload,
            url: '/installs'
        }
    ]
};

export default installs;
